export default class MaxLengths {
  static readonly nameWithSeparator: number = 102;
  static readonly image: number = 250;
  static readonly title: number = 250;
  static readonly name_: number = 100;
  static readonly noteTitle: number = 50;
  static readonly email: number = 320;
  static readonly type: number = 100;
  static readonly text: number = 3000;
  static readonly largeText: number = 10000;
  static readonly mediumText: number = 1000;
  static readonly customMediumText: number = 5000;
  static readonly shortText: number = 500;
  static readonly shorterText: number = 300;
  static readonly gridViewFieldText: number = 100;
  static readonly url: number = 250;
  static readonly fileSizeBytes: number = 10485760;
  static readonly fileSizeBase64: number = 10485760;
  static readonly guid: number = 36;
  static readonly calendarDate: number = 10;
  static readonly phoneNumber: number = 100;
  static readonly voucherCode: number = 11;
  static readonly voucherUserNumber: number = 6;
  static readonly voucherGaNumber: number = 3;
  static readonly countryCode: number = 2;
}
